<div class="header-part">
	<button type="button" mat-stroked-button class="customize-button" (click)="goToCustomizeView()">
		<span class="customize-button-name" translate>datacenter.customize-view</span>
		<mat-icon iconPositionEnd class="customize-button-icon" svgIcon="filters"></mat-icon>
	</button>
	<div>
		<span class="header-note">{{note}}</span>
	</div>
</div>
<ag-grid-angular
	class="ag-theme-balham copo-table-inner-margin"
	[gridOptions]="gridOptions"
	[modules]="agGridModule"
	[columnDefs]="columnDefs"
	[autoGroupColumnDef]="autoGroupColumnDef"
	[rowData]="rowData"
	(gridReady)="onGridReady($event)"
	(viewportChanged)="onViewportChanged($event)"
	[getRowHeight]="getRowHeight"
></ag-grid-angular>